import { useState } from "react";
import { Copy, Check } from "lucide-react";

import { getLoadId } from "@/utils/load";

// Header card above the route stops in the route preview: shows the load's broker reference
// (falling back to the internal id) with a copy-to-clipboard button. Matches LoadboardStop styling.
export const LoadIdCard = ({ load }) => {
    const [copied, setCopied] = useState(false);
    const loadId = load.externalLoadId || getLoadId(load.uniqueId);

    const handleCopy = async () => {
        if (!loadId) return;
        try {
            await navigator.clipboard.writeText(loadId);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // Clipboard access can be denied in some browsers; fail silently rather than
            // throwing a UI error for a non-critical convenience action.
        }
    };

    return (
        <div className="bg-cm-p-background rounded-lg px-3 py-2 flex items-center gap-2">
            <span className="flex-1 min-w-0 break-words text-cm-p-text-primary text-base font-medium">{loadId}</span>
            <button
                type="button"
                onClick={handleCopy}
                aria-label="Copy load ID"
                className="shrink-0 flex items-center justify-center size-6 rounded bg-cm-p-surface-container text-cm-p-text-secondary"
            >
                {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
            </button>
        </div>
    );
};
